import { Tag } from "antd";

export const renderAccessibility = ({ t, val }) => {
  const width = 120;

  switch (val) {
    case 'public':
      return <Tag color="green" style={{ width }} className="text-center">{t('Public')}</Tag>
    case 'acquired':
      return <Tag color="green" style={{ width }} className="text-center">{t('Acquired')}</Tag>
    case 'unrestricted':
      return <Tag color="green" style={{ width }} className="text-center">{t('Unrestricted')}</Tag>
    case 'private':
      return <Tag color="orange" style={{ width }} className="text-center">{t('Private')}</Tag>
    case 'uponAcceptance':
    case 'acceptance':
      return <Tag color="orange" style={{ width }} className="text-center">{t('Upon Acceptance')}</Tag>
    case 'payment':
      return <Tag color="purple" style={{ width }} className="text-center">{t('Upon Payment')}</Tag>
    case 'available':
      return <Tag color="blue" style={{ width }} className="text-center">{t('Available')}</Tag>
    case 'custom':
      return <Tag style={{ width }} className="text-center">{t('Custom')}</Tag>
    case 'own':
      return <Tag color="blue" style={{ width }} className="text-center">{t('Own')}</Tag>
    default:
      return null;
  }
}

export const getTerritory = ({ form, country }) => {
  if (form && form.administrativeLevel2) {
    const { label } = form.administrativeLevel2;

    if (label && typeof label === 'object') {
      const _label = label[`country is ${country}`];
      return _label || 'Territory';
    }
  }

  return 'Territory';
}
